export enum LogType {
  info = 'info',
  error = 'error',
  warning = 'warning',
}

declare const process: { env?: { NODE_ENV?: string } } | undefined;

const isLogEnabled = typeof process !== 'undefined' && process.env?.NODE_ENV !== 'production';

const appLog = (
  type: LogType = LogType.info,
  message?: unknown,
  ...optionalParams: unknown[]
): void => {
  if (!isLogEnabled) {
    return;
  }

  switch (type) {
    case LogType.error:
      // eslint-disable-next-line no-console
      console.error('Slab: ', message, ...optionalParams);
      break;
    case LogType.warning:
      // eslint-disable-next-line no-console
      console.warn('Slab: ', message, ...optionalParams);
      break;
    default:
      // eslint-disable-next-line no-console
      console.log('Slab: ', message, ...optionalParams);
  }
};

const log = (message?: unknown, ...optionalParams: unknown[]): void => {
  appLog(LogType.info, message, ...optionalParams);
};

const error = (message?: unknown, ...optionalParams: unknown[]): void => {
  appLog(LogType.error, message, ...optionalParams);
};

const warn = (message?: unknown, ...optionalParams: unknown[]): void => {
  appLog(LogType.warning, message, ...optionalParams);
};

export const logger = {
  log,
  error,
  warn,
};
